<!-- 资产领用/出库/转移 -->
<template>
  <div class="stock">

    <ScanQR @scan="onScan" @input="onInput"/>

    <transition name="van-fade">
      <van-cell-group
              v-show="assetDetail"
              class="stock-assetDetail"
              :border="false">
          <van-cell title="aaa" value="aaaaa" :border="false"/>
          <van-cell title="aaa" value="aaaaa" :border="false"/>
          <van-cell title="aaa" value="aaaaa" :border="false" />
      </van-cell-group>
    </transition>

    <van-divider content-position="left"></van-divider>

    <van-field
            v-model="remark"
            clearable
            :placeholder="$t('message.heldbyTip')"
            :label="$t('message.heldby')"
            type="text"
    />

    <div class="stock-submit">
      <van-button

              round
              type="primary"
              :loading="submitting"
              :loading-text="$t('message.submitTip')"
              @click="onSubmit"
      > {{$t('message.submit')}} </van-button>
    </div>


  </div>
</template>

<script>
import {
  Button,
  Image,
  Field,
  Icon,
  Cell,
  CellGroup,
  Divider,
  SwitchCell,
  Toast
} from 'vant';
// import { jsConfig } from '@/api/wx';
import ChooseImg from '@/components/chooseImg';
import ScanQR from '@/components/scanQR';
export default {
  components: {
    ScanQR,
    ChooseImg,
    [Button.name]: Button,
    [Image.name]: Image,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Divider.name]: Divider,
    [SwitchCell.name]: SwitchCell,
    Toast
  },

  data() {
    return {
      assetNum: '',
      assetDetail: {},
      question: '',
      remark: '',
      loading: false,
      img1Src: '',
      submitting: false
    };
  },

  methods: {
    photo1(id) {
      Toast(id)
    },
    photo2(id) {
      Toast(id)
    },
    onSubmit() {

    }
  },

  created() {
  }
};
</script>

<style lang="less">
.stock {
  padding: 20px 0 50px 0;

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 40px;
  }

  &-submit {
    text-align: center;
    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }

}
</style>
